/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { axios } from '~/util/http/axioshttp';
import { queryOptions } from '@tanstack/react-query';
import type { InterventionTaskViewModel } from './InterventionTaskViewModel'; 

export function getInterventionTaskVisitBucketCategoryOptions(visitBucketId: string, categoryName: string, onSuccess?: (result: InterventionTaskViewModel[]) => void) {
	return queryOptions({
		queryKey: ['intervention-task-visit-bucket-category', visitBucketId, categoryName],
		queryFn: async () => {
			const url = '/_api/v1/homehealth/visits/queries/getinterventiontaskvisitbucketcategory/' + visitBucketId + '/' + categoryName;
			const resp = await axios.get<InterventionTaskViewModel[]>(url);
			if(onSuccess) {
				onSuccess(resp.data);
			}
			return resp.data;
		},
        enabled: Boolean(visitBucketId) && Boolean(categoryName)
	});
}